import { slice } from './slice';

const { reducer } = slice;

export * as promocodesSelectors from './selectors';
export * from './thunks';

export default reducer;
